module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/10mill-inactive-e1bc1d41990076fc414358004a9aa37e.png";